import CTNModal from '@ctn/ui/components/ctn-modal';
import CTNSpinner from '@ctn/ui/components/ctn-spinner';
import { type CTNModalProps } from '@ctn/ui/types/ctn-modal';
import { useState, useImperativeHandle, forwardRef } from 'react';

export type IModalLoadingRef = {
	open: () => void;
	close: () => void;
};

export type IModalLoadingProps = {
	readonly title?: string;
	readonly descriptionTitle?: string;
	readonly description?: string;
	readonly size?: CTNModalProps['size'];
};

export const ModalLoading = forwardRef<IModalLoadingRef, IModalLoadingProps>(
	({ title, descriptionTitle = 'Cargando...', description = 'Texto de carga', size = 'md' }, ref) => {
		const [isOpen, setIsOpen] = useState(false);

		const openModal = () => {
			setIsOpen(true);
		};

		const closeModal = () => {
			setIsOpen(false);
		};

		useImperativeHandle(ref, () => ({
			open: () => openModal(),
			close: () => closeModal(),
		}));

		return (
			<CTNModal
				autoHeight
				type="basic"
				className="c-pnp-modal-loading"
				title={title}
				show={isOpen}
				closeable={false}
				size={size}
				content={
					<div className="c-pnp-modal-loading__content">
						<CTNSpinner size="size-40" />
						<p className="c-pnp-modal-loading__tit">{descriptionTitle}</p>
						<p>{description}</p>
					</div>
				}
			/>
		);
	},
);

ModalLoading.displayName = 'ModalLoading';

export default ModalLoading;
